var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8142",
    "data-name": "Group 8142",
    transform: "translate(-29 -74)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10187",
    "data-name": "Rectangle 10187",
    width: 20,
    height: 20,
    transform: "translate(29 74)",
    fill: "#9ca1ac",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "folder_copy_FILL0_wght400_GRAD0_opsz48",
    d: "M40.947-868a.912.912,0,0,1-.669-.278.912.912,0,0,1-.278-.669v-9h.947v9H52.474V-868Zm1.895-1.895a.912.912,0,0,1-.669-.278.912.912,0,0,1-.278-.669v-8.211a.912.912,0,0,1,.278-.669.912.912,0,0,1,.669-.278h4.105l.947.947h5.053a.912.912,0,0,1,.669.278.912.912,0,0,1,.278.669v7.263a.912.912,0,0,1-.278.669.912.912,0,0,1-.669.278Zm0-.947H52.947v-7.263H47.5l-.947-.947H42.842Zm0,0v0Z",
    transform: "translate(-8.436 958)",
    fill: "#9ca1ac"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0iR3JvdXBfODE0MiIgZGF0YS1uYW1lPSJHcm91cCA4MTQyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjkgLTc0KSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzEwMTg3IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxMDE4NyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOSA3NCkiIGZpbGw9IiM5Y2ExYWMiIG9wYWNpdHk9IjAiLz4KICAgIDxwYXRoIGlkPSJmb2xkZXJfY29weV9GSUxMMF93Z2h0NDAwX0dSQUQwX29wc3o0OCIgZD0iTTQwLjk0Ny04NjhhLjkxMi45MTIsMCwwLDEtLjY2OS0uMjc4LjkxMi45MTIsMCwwLDEtLjI3OC0uNjY5di05aC45NDd2OUg1Mi40NzRWLTg2OFptMS44OTUtMS44OTVhLjkxMi45MTIsMCwwLDEtLjY2OS0uMjc4LjkxMi45MTIsMCwwLDEtLjI3OC0uNjY5di04LjIxMWEuOTEyLjkxMiwwLDAsMSwuMjc4LS42NjkuOTEyLjkxMiwwLDAsMSwuNjY5LS4yNzhoNC4xMDVsLjk0Ny45NDdoNS4wNTNhLjkxMi45MTIsMCwwLDEsLjY2OS4yNzguOTEyLjkxMiwwLDAsMSwuMjc4LjY2OXY3LjI2M2EuOTEyLjkxMiwwLDAsMS0uMjc4LjY2OS45MTIuOTEyLDAsMCwxLS42NjkuMjc4Wm0wLS45NDdINTIuOTQ3di03LjI2M0g0Ny41bC0uOTQ3LS45NDdINDIuODQyWm0wLDB2MFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjQzNiA5NTgpIiBmaWxsPSIjOWNhMWFjIi8+CiAgPC9nPgo8L3N2Zz4K";